import { render, staticRenderFns } from "./MenuPopup.vue?vue&type=template&id=27e19a4c&"
import script from "./MenuPopup.vue?vue&type=script&lang=js&"
export * from "./MenuPopup.vue?vue&type=script&lang=js&"
import style0 from "./MenuPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports